import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { toast } from "react-toastify";

const Documents = ({ assetId }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    document_file: null,
  });

  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    loadDocuments();
  }, []);

  const loadDocuments = async () => {
    const res = await axios.get(`${API_BASE_URL}/asset/${assetId}/documents`);
    setDocuments(res.data);
  };

  const submitDocument = async (e) => {
    e.preventDefault();

    if (!formData.document_file) {
return toast.error("Please upload a document file", {
  position: "bottom-right"
});
    }

    const fd = new FormData();
    fd.append("asset_id", assetId);
    fd.append("title", formData.title);
    fd.append("description", formData.description);
    fd.append("document_file", formData.document_file);

    try {
      await axios.post(`${API_BASE_URL}/asset/document/add`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

toast.success("Document Uploaded!", {
  position: "bottom-right"
});
      setFormData({ title: "", description: "", document_file: null });
      loadDocuments();
    } catch (err) {
      toast.error(err.response?.data?.message || "Upload failed");
    }
  };

  return (
    <div className="card p-3">
      <h5>Add Document</h5>

      <form onSubmit={submitDocument}>
        <div className="row">
          <div className="col-md-6">
            <label>Title</label>
            <input
              type="text"
              className="form-control"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            />

            <label className="mt-3">Upload Document</label>
            <input
              type="file"
              className="form-control"
              onChange={(e) =>
                setFormData({ ...formData, document_file: e.target.files[0] })
              }
            />
          </div>

          <div className="col-md-6">
            <label>Description</label>
            <textarea
              className="form-control"
              rows="4"
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
            />
          </div>
        </div>

        <button className="btn btn-primary mt-3" type="submit">
          Upload
        </button>
      </form>

      <h5 className="mt-4">Document List</h5>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th>File</th>
            <th>Added On</th>
          </tr>
        </thead>
        <tbody>
          {documents.map((doc) => (
            <tr key={doc.doc_id}>
              <td>{doc.doc_title}</td>
              <td>{doc.doc_desc}</td>
              <td>
                <a
                  href={`${API_BASE_URL}/uploads/asset_document/${doc.doc_file}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {doc.doc_file}
                </a>
              </td>
              <td>{doc.added_on}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Documents;
